import {CommonScenario} from './CommonScenario';
import {HemisphereLight} from '../HemisphereLight';
import {ColorInterpolation} from '../../../classes/ColorInterpolation';

declare const THREE: any;

export class Lakefront extends CommonScenario {

  protected createHemisphereLight(): HemisphereLight {
    return new HemisphereLight(
      new ColorInterpolation(
        new THREE.Color(0xf2ffff),
        new THREE.Color(.6, .6, .6)
      ),
      new ColorInterpolation(
        new THREE.Color(0x6a686b),
        new THREE.Color(.1, .1, .1)
      ),
      1
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/custom/env/scenarios/Lakefront.ts